import * as React from "react";

export const PERIOD_MONTHS_CONVERSION = {
    1: "Monthly",
    3: "Quarterly",
    12: "Yearly",
}

export const MONTHS_PERIOD_CONVERSION = {
    "Monthly": 1,
    "Quarterly": 3,
    "Yearly": 12,
}

export const YEARLY_BENEFITS = [
    "15% Off First Order"
]

export const SUBSCRIPTION_TAGLINES = {
    Loyalty: "I want exclusive savings on print and mail marketing items.",
    Reach: "I want to grow my digital presence.",
    Premium: "I want both!"
}

export const Banner = ({content, xdQaName}) => (
    <div className="banner">
        <div 
            className="blue-rectangle"
            xd-qa-type="label"
            xd-qa-name={xdQaName}
        >{content}</div>
    </div>
)

export const SubscribeButton = ({activeSubscription, planDetails, subscriptionModal, changePlanModal, content}) => (
    <div className="subscribe-button">
        <button 
            className="primary"
            onClick={() => activeSubscription.status === "cancelled" ? (
                subscriptionModal.show({planId: planDetails.idChargebeePricePoint})
            ) : (
                changePlanModal.show()
            )}
            xd-qa-type="button"
            xd-qa-name={content}
        >
            {content}
        </button>
    </div>
)

const getChargebeeId = ({subscriptionPlans, planSelected, advertisedPlan}) => {
    const selectedPlan = subscriptionPlans.find(plan => plan.label === planSelected.label);
    if (selectedPlan) {
        const {pricePoints} = selectedPlan;
        const selectedPricePoint = pricePoints.find(pricePoint => pricePoint.periodMonths === advertisedPlan);
        if (selectedPricePoint) {
            return selectedPricePoint.idChargebeePricePoint;
        }
    }
    return null;
};